

import CommonApi from './../commonApi';

const maintenanceCostAllocationTR = new CommonApi(
  'maintenanceCostAllocationTR',
  'Распределение затрат на ТР'
);

export default {
  ...maintenanceCostAllocationTR
};
